import redirectToLogin from 'webmango-utils/redirect'
export default redirectToLogin



// WEBPACK FOOTER //
// ../webmango-core/redirect.js